export const SOCIAL_EDGE_CATEGORY_OPTIONS = [
  { value: 'friendship', label: 'Friends', color: '#00d5ff' },
  { value: 'dating', label: 'Lovers', color: '#ff2d95' },
  { value: 'family', label: 'Family', color: '#32ff6a' },
  { value: 'college', label: 'College', color: '#8b5cf6' },
  { value: 'grade_school', label: 'Grade school', color: '#ff8a00' },
  { value: 'coworkers', label: 'Coworkers', color: '#ffd60a' },
];

export const FAMILY_EDGE_CATEGORY_OPTIONS = [
  { value: 'child', label: 'Child', color: '#32ff6a' },
  { value: 'sibling', label: 'Sibling', color: '#00d5ff' },
  { value: 'partner', label: 'Partner', color: '#ff2d95' },
  { value: 'married', label: 'Married', color: '#ffd60a' },
  { value: 'family', label: 'Family', color: '#8b5cf6' },
];

export const WEDDING_EDGE_CATEGORY_OPTIONS = [
  { value: 'married', label: 'Couple', color: '#ffd60a' },
  { value: 'family', label: 'Family', color: '#32ff6a' },
  { value: 'wedding_party', label: 'Wedding Party', color: '#ff2d95' },
  { value: 'friendship', label: 'Friends', color: '#00d5ff' },
  { value: 'guest', label: 'Guest', color: '#8b5cf6' },
];

export const EDGE_CATEGORY_OPTIONS = SOCIAL_EDGE_CATEGORY_OPTIONS;

export function normalizeEdgeCategory(category) {
  return category === 'school' ? 'college' : category;
}

export function getEdgeCategoryOptions(graphType = 'social') {
  if (graphType === 'family') return FAMILY_EDGE_CATEGORY_OPTIONS;
  if (graphType === 'wedding') return WEDDING_EDGE_CATEGORY_OPTIONS;
  return SOCIAL_EDGE_CATEGORY_OPTIONS;
}

export function getEdgeCategoryColor(category) {
  const normalizedCategory = normalizeEdgeCategory(category);
  const allOptions = [
    ...SOCIAL_EDGE_CATEGORY_OPTIONS,
    ...FAMILY_EDGE_CATEGORY_OPTIONS,
    ...WEDDING_EDGE_CATEGORY_OPTIONS,
  ];
  return allOptions.find((option) => option.value === normalizedCategory)?.color || SOCIAL_EDGE_CATEGORY_OPTIONS[0].color;
}

export function getEdgeCategoryLabel(category) {
  const normalizedCategory = normalizeEdgeCategory(category);
  const allOptions = [
    ...SOCIAL_EDGE_CATEGORY_OPTIONS,
    ...FAMILY_EDGE_CATEGORY_OPTIONS,
    ...WEDDING_EDGE_CATEGORY_OPTIONS,
  ];
  return allOptions.find((option) => option.value === normalizedCategory)?.label || SOCIAL_EDGE_CATEGORY_OPTIONS[0].label;
}
